var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarCategoryOff = function SvgNavbarCategoryOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M11.228 11.25h-9v-9h9zm-1.5-1.5h-6v-6h6zm12 1.5h-9v-9h9zm-1.5-1.5h-6v-6h6zm-7.5 12h9v-9h-9zm1.5-1.5h6v-6h-6zm-12-7.5h9v9h-6a3 3 0 0 1-3-3zm7.5 7.5v-6h-6v4.5c0 .827.672 1.5 1.5 1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarCategoryOff;